import React, {useEffect, useRef, useState} from "react";
import {getCoursesVisible} from "../service";
import {CoursesData, TelecastsData, TrainingsData} from "./types";
import CourseItem from './course/course-item'
import banner from '../images/c-banner.jpg'
import ImageBox from "../components/Image"
import FixedTabs from "../components/fixed-tabs";
import Trainings from "./discovery/trainings";
import usePagination from "../routers/usePagination";
import Pagination from "../components/pagination";
import {priceConvert} from "../units";
import {useLocation} from "react-router";
import { parse,stringify } from "qs";

type Courses = Array<CoursesData>

const Course = () => {
    const session = window.sessionStorage.getItem('course_tab_active')
    const [active, setActive] = useState<number>(session ? Number(session) :0);
    const [pageNum,setPage] = useState<number>(1);
    const [lists, setLists] = useState<Courses>([]);
    const tabRef = useRef(null)
    const { pageRef,noMore,reset } = usePagination();


    useEffect(() => {
        // console.log(active,tabs)
        if(active === 0){
            getCoursesVisible({
                pageNum,
            }).then(res => {
                const lists = res.data.list
                if((lists as Courses).length > 0){
                    setLists(list => list.concat(lists))
                }else{
                    noMore()
                }
            })
        }
    }, [pageNum,active])


    return <div className="course navPage">

       <div className="banner">
           <ImageBox height={45.65} src={banner} radius={15}/>
       </div>

        <FixedTabs active={active} ref={tabRef} autoFixed tabs={ ['线上课程','线下课程'] } onChange={(index) => {
            reset()
            // setActiveT(index)
            window.sessionStorage.setItem('home_tab_active','' + index)
            setActive(index)
        }}/>

        {
            active === 0 && <div className="online" style={{ padding:'.3rem' }}>
                <CourseItem lists={lists} render={(props:CoursesData) =>
                {
                    return <>
                        <div className="l">{ props.chapterQuantity }节课时</div>
                        <p className="p"><span>￥</span> { priceConvert(props.coursePrice) } </p>
                    </>
                }
                }/>
                <Pagination length={ lists.length } ref={pageRef}  onChange={ (n) => setPage(n) }/>
            </div>
        }
        {
            active === 1 && <Trainings />
        }
    </div>
}

export default Course;
